import { Modal } from "@sebgroup/green-react";
import FocusLock from "react-focus-lock";

export interface SlideoutProps {
  id: string;
  header: string;
  body: string;
  onClose: (payload: { id: string }) => void;
}

function Slideout(props: SlideoutProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape") {
      handleClose();
    }
    e.stopPropagation();
  };

  const handleClose = () => {
    props.onClose({ id: props.id });
  };

  return (
    <FocusLock>
      <div onKeyDown={handleKeyDown}>
        <Modal header={props.header} isOpen onClose={handleClose} type="slideout">
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: props.body,
            }}
          />
        </Modal>
      </div>
    </FocusLock>
  );
}

export default Slideout;
